import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ThoughtBubbleFlowSchema = withDefaults({
  type: 'thought-bubble-flow',
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'flowType',
    },
    {
      kind: 'attribute',
      name: 'app',
    },
    {
      kind: 'attribute',
      name: 'route',
    },
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'attribute',
      name: 'priority',
    },
    {
      kind: 'attribute',
      name: 'targetingRules',
    },
    {
      kind: 'attribute',
      name: 'enabledDomains',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'updatedBy',
    },
    {
      kind: 'attribute',
      name: 'invocationsCount',
    },
    {
      kind: 'attribute',
      name: 'companyInvocationsCount',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'hasMany',
      name: 'steps',
      type: 'thought-bubble-step',
      options: {
        async: false,
        inverse: 'flow',
      },
    },
  ],
});

export default ThoughtBubbleFlowSchema;
